import React from 'react';

import Layout from 'client/app/apps/disco-prototype/Demov2Page/Layout';
import Page from 'client/app/apps/disco-prototype/Demov2Page/Page';

export default () => (
  <Layout>
    <Page />
  </Layout>
);
